import { Button, ButtonColor } from '@leland-dev/leland-ui-library';
import React, { type FC } from 'react';

interface OopsProps {
  className?: string;
  description: string;
  retry: () => void;
}

export const Oops: FC<OopsProps> = ({ className = '', description, retry }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center py-10 ${className}`}
    >
      <h2 className="text-2xl font-medium text-leland-gray-dark">
        Oops! Something went wrong!
      </h2>
      <h4 className="mt-4 text-lg font-normal text-leland-gray-light">
        {description}
      </h4>
      <div className="mt-6">
        <Button
          label="Try again"
          buttonColor={ButtonColor.WHITE}
          // ensure we don't accidentally pass click event through to `retry`
          onClick={() => retry()}
        />
      </div>
    </div>
  );
};
